import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import { updateProfessional } from "../services/update-professional";
import { CreateProfessionalInput } from "../services/create-professional";


export function useUpdateProfessional() {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: ({ id, data }: { id: string; data: CreateProfessionalInput }) =>
        updateProfessional(id, data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["professionals"] });
        toast({ title: "Professional updated successfully" });
      },
      onError: (error: any) => {
        console.error("Error updating professional:", error);
        // Nest's validation errors arrive as an array of messages.
        const message = error?.response?.data?.message;
        toast({
          title: "Failed to update professional",
          description: Array.isArray(message) ? message.join(", ") : message,
          variant: "destructive",
        });
      },
    });
  }
